import React, { useState, useEffect } from "react";
import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { bindActionCreators } from "redux";
import { InputGroup, FormControl, Tabs, Tab } from "react-bootstrap";
import AdvancedFilter from './AdvancedFilter';
import CollectionsListBox from "../../components/dashboard/CollectionsListBox";
import ProcessingArea from "../../components/dashboard/ProcessingArea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { XIcon } from "@heroicons/react/outline";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// API Urls
import { getItems, deleteItem, updateFilteredItems } from "../../actions/items";
import { updateFilter, resetFilter } from "../../actions/filters";
import { getActivities } from "../../actions/activity";
import {
  addWish,
  updateWish,
  deleteWish,
  addUpvoteWish,
  deleteUpvoteWish,
  getWishs
} from "../../actions/wishs";
import {
  fetchSettings,
  getUsers,
  deleteCollection,
  getCollections,
  getUserSiteContent,
  getCollection,
  addItemToCollection,
  removeItemFromCollection,
  createSite,
  deleteSite,
  getUserInfo
} from "../../actions/settings";
import { getCtasList } from "../../actions/ctas";
import { getSubscriptions } from "../../actions/subscription";
import {SearchClient} from "../../lib/SearchClient";
import HistoryCard from "../../components/dashboard/HistoryCard";
import WishListBox from "../../components/dashboard/WishListBox";
import ItemCards from "../../components/dashboard/ItemCards";
import ItemFilterBar from "../../components/dashboard/ItemFilterBar";
// import imgUpload from "../../assets/images/upload_document.png";
import DeleteConfirmForm from '../../components/settings/DeleteConfirmForm';
import PublishMicrositeForm from '../../components/settings/PublishMicrositeForm';
import { StateMachineManager } from '../../utils/stateMachine';
import { toggleMachine } from '../../machines/ToggleMachine';

import "./index.scss";

const ReactSwal = withReactContent(Swal);
const Dashboard = (props) => {
  const exSearchKey = useSelector(({ filters }) => filters.searchKey)
  const [items, setItems] = useState([]);
  const [searchKey, setSearchKey] = useState(exSearchKey || '');
  const [current, setCurrent] = useState(toggleMachine.initialState);
  const { collectionId } = useParams();

  const onSearch = async () => {
    initSearch();

    if (searchKey === '') {
      // clear search results or original state
      const searchClient = SearchClient.getClient();
      if (searchClient) {
        searchClient.clear();
      }
    }
    
    let filteredItems = [];
    const searchClient = SearchClient.getClient();

    if (searchClient) {
      filteredItems = await searchClient.searchItems(searchKey);
    }

    props.updateFilteredItems(filteredItems);
    setItems(filteredItems);
  }

  const debouncedHandler = _.debounce(onSearch, 550);

  useEffect(() => {
    props.getUserInfo();
    props.getUsers();
    props.getUserSiteContent();
    //////
    setItems(props.filteredItems);
    props.getItems();
    props.fetchSettings();
    props.getActivities();
    props.getWishs();
    props.getCtasList();
    props.getSubscriptions(props.tenant.tenantId);
    StateMachineManager.Instance.setChangeStateHandler(curr => setCurrent(curr));
    setSearchKey(_.get(props.filters, 'searchKey', ''));
  }, []);

  useEffect(() => {
    props.updateFilter({ searchKey });
  }, [searchKey]);

  useEffect(() => {
    if (props.cognitoUser) {
      const searchClient = SearchClient.getClient();
      if (searchClient) {
        searchClient.clear();
      }

      debouncedHandler();
    }
  }, [props.items, props.filters, props.cognitoUser]);

  // Handle the page load with a direct URL or navigation to a collection
  useEffect(() => {
    if (props.collections.length > 0) {
      const collectionId = _.get(props, 'match.params.collectionId', null);
      const urlPath = _.get(props, 'match.path', '');

      if (collectionId) {
        const selCollection = props.collections.find((ct) => ct.id === collectionId);

        if (!selCollection) {
          props.history.push('/');
          return;
        }

        if (urlPath.includes('/edit')) {
          StateMachineManager.Instance.service.send('SWITCH_COLLECTION_EDITING', { collection: selCollection });
        } else {
          StateMachineManager.Instance.service.send('SWITCH_COLLECTION_SELECT', { collection: selCollection });
        }
      }
    }
  }, [props.collections, collectionId])

  // Handle a collection detail path, /collections/detail/:collectionId
  // useEffect(() => {
  //   if (collectionId) {
  //     const selectedCollection = props.collections.find(col => col.id === collectionId);
  //     if (selectedCollection) {
  //       StateMachineManager.Instance.service.send('SWITCH_COLLECTION_SELECT', { selectedCollection });
  //       props.history.push(`/collections/detail/${selectedCollection.id}`);
  //     }
  //   } else {
  //     StateMachineManager.Instance.service.send('SWITCH_CONTENT_MODE');
  //     props.history.push('/');
  //   }
  // }, [collectionId]);

  const onChangeFilter = (filters) => {
    props.updateFilter(filters);
    props.history.push('/');
  }

  /**
   * Set up search if it's not already all set to go
   * @see https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/pagination/js/ 
   */
  const initSearch = () => {
    if (_.get(props.filters, 'funnelStages', undefined) === undefined) {
      const searchOptions = _.get(props, "settings.userInfo.searchOptions", null);

      if (!searchOptions) {
        SearchClient.getClient(props.tenant.tenantId, props.tenant.algoliaPublicKey).clear();
      } else {
        SearchClient.getClient(props.tenant.tenantId, props.tenant.algoliaPublicKey, searchOptions);
      }
    } else {
      const searchOptions = {
        funnelStage: _.get(props.filters, 'funnelStages', []),
        contentType: _.get(props.filters, 'contentTypes', []),
        tags: _.get(props.filters, 'contentTags', []),
        products: _.get(props.filters, 'contentProducts', []),
        industries: _.get(props.filters, 'contentIndustries', []),
        regions: _.get(props.filters, 'contentRegions', [])
      }

      SearchClient.getClient(props.tenant.tenantId, props.tenant.algoliaPublicKey, searchOptions);
    }
  }

  const debounceSearch = (e) => {
    setSearchKey(e.target.value);
    props.history.push('/');
  }

  // //////////////////////////////////////////
  // Collections

  // Intercept addItemToCollection to track processing items
  const handleAddItemToCollection = (itemId, collectionId) => {
    // Find the item in the items state by ID
    const item = props.items.find((it) => it.id === itemId) || {};

    // ProcessingArea expects the item object itself, not just the ID
    if (current.event.collection) {
      // Call the original method
      return props.addItemToCollection(itemId, collectionId);
    } else {
      // Just pass through if we're not in collection mode
      return props.addItemToCollection(itemId, collectionId);
    }
  };

  const onSelectCollection = (collection) => {
    if (!current.event.collection || current.event.collection.id !== collection.id) {
      StateMachineManager.Instance.service.send('SWITCH_COLLECTION_SELECT', { collection });
      props.history.push(`/collections/detail/${collection.id}`);
    } else {
      StateMachineManager.Instance.service.send('SWITCH_CONTENT_MODE');
      props.history.push('/');
    }
  }

  const onStartCollectionEditing = (collection) => {
    StateMachineManager.Instance.service.send('SWITCH_COLLECTION_EDITING', { collection });
    props.history.push(`/collections/detail/${collection.id}/edit`);
  }

  const onDeleteCollection = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type="collection"
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
          collection={current.event.collection}
        />
      )
    })
    .then(result => {
      if (result.value) {
        props.deleteCollection(current.event.collection);
        StateMachineManager.Instance.service.send('SWITCH_CONTENT_MODE');
      }
    });
  }

  const onPublishMicrosite = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <PublishMicrositeForm
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
          createSite={props.createSite}
          collection={current.event.collection}
          ctas={props.ctas}
        />
      )
    })
    .then(result => {
      if (result.value) {
        StateMachineManager.Instance.service.send('SWITCH_CONTENT_MODE');
      }
    });
  }

  const onEndEditing = () => {
    const collection = current.event.collection
    StateMachineManager.Instance.service.send('SWITCH_COLLECTION_SELECT', { collection });
    // props.history.push(`/collections/detail/${collection.id}`);
  }

  // /////////////////////////////////////////
  // Items

  const deleteItemHandler = id => {
    props.deleteItem(id);
    setItems(items.filter(it => it.id !== id));
  }

  // /////////////////////////////////////////
  // Filters


  const onTagSelect = tagKey => {
    setSearchKey(`"${tagKey}"`);

    props.resetFilter();
  }

  const onChangeFilterHandler = async (isReset, filters) => {
    props.updateFilter({ searchKey: isReset ? '' : searchKey, ...filters }, !isReset);
    setSearchKey('');
    props.history.push('/');
  }

  const onClearFilter = () => {
    const defaultFilters = _.get(props.settings, 'userInfo.searchOptions', {});

    const filterValues = {
      funnelStages: [],
      contentTypes: [],
      contentTags: _.get(defaultFilters, 'tags', []),
      contentRegions: _.get(defaultFilters, 'regions', []),
      contentProducts: _.get(defaultFilters, 'products', []),
      contentIndustries: _.get(defaultFilters, 'industries', []),
      searchKey: ''
    };

    const searchOptions = {
      funnelState: [],
      contentType: [],
      tags: _.get(defaultFilters, 'tags', []),
      regions: _.get(defaultFilters, 'regions', []),
      products: _.get(defaultFilters, 'products', []),
      industries: _.get(defaultFilters, 'industries', [])
    };

    const searchClient = SearchClient.getClient();
    if (searchClient) {
      searchClient.updateSearchOptions(searchOptions);
    }

    onChangeFilterHandler(true, filterValues);
    setSearchKey('');
  }

  const calcFiltersCount = () => {
    const funnelFilterCount = _.get(props.filters, 'funnelStages', []).length;
    const typeFilterCount = _.get(props.filters, 'contentTypes', []).length;
    const tagFilterCount = _.get(props.filters, 'contentTags', []).length;
    const productFilterCount = _.get(props.filters, 'contentProducts', []).length;
    const industryFilterCount = _.get(props.filters, 'contentIndustries', []).length;
    const regionFilterCount = _.get(props.filters, 'contentRegions', []).length;

    return funnelFilterCount + typeFilterCount + tagFilterCount + productFilterCount + industryFilterCount + regionFilterCount;
  };

  const { filters, filteredItems } = props;
  const isAdmin = _.get(props, "cognitoUser.attributes['custom:role']", '') === 'admin';
  const userId = _.get(props.settings, 'userInfo.userId', '');

  // filter out items fetched that are private to another owner (in a private collection)
  // and are not shared with the current user
  // given the user is not an admin
  let sharedBys = [];
  if (props.collections && props.collections.length > 0) {
    sharedBys = props.collections.filter(c => !!c.sharedBy).map(c => c.sharedBy);
  }
  let currentItems = items.filter(it => {
    if (!isAdmin) {
      // if there's an owner id and the owner isn't the current user 
      // AND the owner hasn't shared it with the current user
      if (it.ownerId && ((it.ownerId !== userId) && !sharedBys.includes(it.ownerId))) {
        return false;
      }
    }
    return true;
  });
  
  let collectionItems = [];

  const sharedBy = _.get(current.event, 'collection.sharedBy', null);

  if (current.event.collection) {
    const currentCollection = props.collections.find(col => col.id === current.event.collection.id);
    
    if (current.value !== 'collectionEditing') {
      const collectionItemIds = _.get(currentCollection, 'items', []);

      // the collection items are subject to search
      collectionItems = collectionItemIds.map(ciId => {
        const curItem = props.items.find(it => it.id === ciId);

        return curItem;
      });

      currentItems = [ ...collectionItems ];
    }

    if (current.value === 'collectionEditing') {
      // the current collection is the total items fetched that match the collection
      // don't change this according to the search in this case
      // TODO don't recalc on every search
      const collectionItemIds = _.get(currentCollection, 'items', []);

      if (sharedBy !== null && (sharedBy !== userId && !isAdmin)) {
        // map and find to preserve collection id order
        collectionItems = collectionItemIds.map(ciId => {
          const curItem = props.items.find(it => it.id === ciId);
            return curItem;
        });
        currentItems = [ ...collectionItems ];
      } else {
        // filter items down by the collection
        // map and find (vs filter only) for preserving collection ordering
        collectionItems = collectionItemIds.map(ciId => {
          const curItem = props.items.find(it => it.id === ciId);
            return curItem;
        });

        // see the full list of items when editing a collection
        currentItems = items.length === 0 ? filteredItems : items;
        currentItems = currentItems.filter(item => !collectionItemIds.find(ciId => ciId === item.id));
      }
    }
  }

  return (
    <div className="dashboard-container">
      <div className="filter-sidebar">
        <div className="search-bar">
          <FontAwesomeIcon icon={faSearch} />
          <InputGroup className="">
            <FormControl
              id="search-input"
              name="search-input"
              placeholder="Find it here..."
              aria-label="Search"
              aria-describedby="basic-addon1"
              onChange={debounceSearch}
              // ref={searchRef}
              value={searchKey || ''}
            />
          </InputGroup>
          {(searchKey !== '' || calcFiltersCount() > 0) && <XIcon className="clear-search" onClick={onClearFilter} />}
          <AdvancedFilter onChange={onChangeFilterHandler} />
        </div>
        <CollectionsListBox
          onSelect={onSelectCollection}
          onEditing={onStartCollectionEditing}
          collections={props.collections}
          sites={props.sites || []}
          Analytics={props.Analytics}
          collection={current.event.collection}
        />
      </div>
      <div className="dashboard-content">
        <ItemFilterBar
          onChange={onChangeFilter}
          settings={props.settings}
          filters={filters}
          isAdmin={isAdmin}
          Analytics={props.Analytics}
          itemCount={currentItems.length}
        />
        {current.value === 'collectionEditing' && 
          <ProcessingArea
            collection={current.event.collection}
            site={props.sites.find(st => st.collectionId === current.event.collection.id)}
            onDeleteCollection={onDeleteCollection}
            onPublishMicrosite={onPublishMicrosite}
            addItemToCollection={handleAddItemToCollection} // intercept to set processing items
            items={collectionItems.filter(item => item !== undefined)} // filter out deleted items
            onRemoveItem={props.removeItemFromCollection}
            onEndEditing={onEndEditing}
            onDeleteSite={props.deleteSite}
        />}
        <ItemCards
          items={currentItems}
          horizontal={filters.gridStyle}
          history={props.history}
          openUpload={(file) => props.openUploadModal(file, '/dashboard')}
          filters={filters}
          onTagSelect={onTagSelect}
          searchKey={searchKey}
          isAdmin={isAdmin}
          settings={props.settings}
          isCollection={current.event.collection !== null && current.event.collection !== undefined && current.value !== 'collectionEditing'}
          currentStatus={current.value === 'collectionEditing' ? (sharedBy === null || sharedBy === userId ? 'collectionEditing' : 'none' ) : current.value}
          deleteItem={deleteItemHandler}
          className={collectionItems.length > 0 ? '' : 'collection-empty-state'}
        />
        {/* {currentItems && currentItems.length === 0 && <img src={imgUpload} alt="upload" className="position-absolute" style={{ bottom: 0 }} />} */}
      </div>
      <div className="recent-history-wrapper">
        <Tabs defaultActiveKey="recent_activity" transition={false} id="noanim-tab-example">
          <Tab eventKey="recent_activity" title="Recent activity">
            <HistoryCard activities={props.activities} />
          </Tab>
          <Tab eventKey="wishList" title="WishList">
            <WishListBox
              wishs={props.wishs}
              contentTypes={props.settings.contentTypes}
              addWish={props.addWish}
              updateWish={props.updateWish}
              deleteWish={props.deleteWish}
              cognitoUser={props.cognitoUser}
              wishlistUrgency={props.settings.wishlistUrgency}
              addUpvoteWish={props.addUpvoteWish}
              deleteUpvoteWish={props.deleteUpvoteWish}
              Analytics={props.Analytics}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  items: _.get(state, 'item.items', []),
  filteredItems: _.get(state, 'item.filtered', []),
  tenant: state.auth.tenant,
  settings: state.settings,
  filters: state.filters,
  cognitoUser: state.auth.cognitoUser,
  activities: state.activity.activities || [],
  wishs: state.wishlist.wishs || [],
  Analytics: state.auth.Analytics,
  collections: _.get(state, 'settings.userSiteContent.collections', []).filter(ct => !ct.deletedAt),
  sites: _.get(state, 'settings.userSiteContent.sites', []).filter(st => !st.deletedAt),
  subscriptions:state.subscriptions,
  ctas: state?.settings?.ctas || [],
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  updateFilter,
  resetFilter,
  fetchSettings,
  getItems,
  getActivities,
  getWishs,
  getCtasList,
  addWish,
  updateWish,
  deleteWish,
  addUpvoteWish,
  deleteUpvoteWish,
  getUsers,
  deleteCollection,
  getCollections,
  getCollection,
  addItemToCollection,
  removeItemFromCollection,
  getUserSiteContent,
  createSite,
  deleteSite,
  getUserInfo,
  deleteItem,
  updateFilteredItems,
  getSubscriptions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
